import React, { useState } from 'react'
import DesignCardView from '../common/DesignCardView'
import { getUserPreference, groupByKey } from '../../helpers/Util'
import { useDispatch } from 'react-redux'
import { closeLoader, openLoader } from '../../redux_toolkit/Loader'
import SharedCollectionThunk from '../../redux_toolkit/V3/SharedCollection/SharedCollectionThunk'
import { FavouriteThunks } from '../../redux_toolkit/Favourite/FavouriteThunks'
import { DoFavouriteThunk } from '../../redux_toolkit/V3/DoFavourite/DoFavouriteThunk'
import {
    GET_FAVOURITE_COUNT,
    SELECT_DESIGN_FOR_FAVOURITE,
    TOGGLE_FAVOURITE_COLLECTION,
    UNSELECT_DESIGN_FOR_FAVOURITE
} from '../../redux_toolkit/@types/thunk.types'
import { useGlobalState } from '../../redux_toolkit/V3/Common'
import { ReactComponent as FavouriteIcon } from '../../../assets/icons/favorite.svg'
import { ReactComponent as FavouritedIcon } from '../../../assets/icons/favorited.svg'
import { ReactComponent as ConversationIcon } from '../../../assets/icons/chat.svg'
import { openConversationView } from '../../redux_toolkit/Conversation/ConversationViewSlice'
import AddToFavourite from '../common/AddToFavourite'
import ConfirmationModal from '../../common/ConfirmationModal'

const SharedCollectionStyleView = ({
    designList,
    collectionResponseList,
    setDesignList,
    setCollectionResponseList
}) => {
    const [selectedCollectionId, setSelectedCollectionId] = useState(null)
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [showFavourite, setShowFavourite] = useState(false)
    const dispatch = useDispatch()
    const trackId = useGlobalState()?.productTrackId
    const defaultFavFolder = getUserPreference()?.defaultFavouriteFolder

    const getCollectionDetails = (collectionId) => {
        return collectionResponseList?.find(
            (collection) => collection.id === collectionId
        )
    }

    const handleOpenConversation = (id) => {
        dispatch(
            openConversationView({
                id,
                type: 'COLLECTION_COMMENT',
                conversationsType: 'COLLECTION_CONVERSATION'
            })
        )
    }

    const toggleCollectionFavourite = async (bool, collectionId) => {
        try {
            dispatch(openLoader())

            await dispatch(
                SharedCollectionThunk[TOGGLE_FAVOURITE_COLLECTION](
                    bool,
                    collectionId,
                    defaultFavFolder?.id
                )
            )
            if (bool) await dispatch(FavouriteThunks[GET_FAVOURITE_COUNT]())

            let updatedCollectionResponseList = collectionResponseList.map(
                (item) => {
                    if (item.id === collectionId) {
                        return { ...item, isFavorite: bool }
                    }
                    return item
                }
            )
            setCollectionResponseList(updatedCollectionResponseList)

            let updatedDesignList = designList.map((design) => {
                if (design.collectionId === collectionId) {
                    return { ...design, liked: bool }
                }
                return design
            })

            setDesignList(updatedDesignList)
            setOpenConfirmation(false)
            setSelectedCollectionId(null)
            dispatch(closeLoader())
        } catch (e) {
            dispatch(closeLoader())
            setOpenConfirmation(false)
        }
    }

    const toggleDesignFavourite = async (
        bool,
        designInfo,
        isShowFav = true
    ) => {
        if (bool === true) {
            await dispatch(
                DoFavouriteThunk[SELECT_DESIGN_FOR_FAVOURITE](
                    designInfo,
                    trackId
                )
            )
        } else {
            await dispatch(
                DoFavouriteThunk[UNSELECT_DESIGN_FOR_FAVOURITE](designInfo)
            )
        }
        await dispatch(FavouriteThunks[GET_FAVOURITE_COUNT]())

        let updatedDesignList = designList.map((item) => {
            if (item.id === designInfo.id) {
                return { ...item, liked: bool }
            }
            return item
        })
        setDesignList(updatedDesignList)

        if (!designInfo?.isSold) {
            setShowFavourite(true)
        } else {
            setShowFavourite(false)
        }
    }

    const renderGroupedDesignCards = () => {
        const groupedData = groupByKey(designList, 'collectionId')
        return Array.from(groupedData.keys()).map((collectionId, index) => {
            const designs = groupedData.get(collectionId)
            const collectionDetails = getCollectionDetails(
                parseInt(collectionId)
            )

            if (!collectionDetails) return null

            return (
                <div key={`collection_${index}`} className='collection-group'>
                    <div className='collection-header flex justify-between items-center'>
                        <div>
                            <div className='flex'>
                                <h3 className='regular-18 weight-500 mb-0'>
                                    {collectionDetails?.name}
                                </h3>
                                <button
                                    className='button icon-only !px-0 !py-0 ml-2'
                                    onClick={() => {
                                        setOpenConfirmation(true)
                                        setSelectedCollectionId(
                                            collectionDetails?.id
                                        )
                                    }}
                                >
                                    <FavouriteIcon />
                                </button>
                            </div>

                            <ul className='common-list-component'>
                                {collectionDetails?.season && (
                                    <li>{collectionDetails?.season}</li>
                                )}
                                {collectionDetails?.numOfDesign && (
                                    <li>
                                        {collectionDetails?.numOfDesign} Styles
                                    </li>
                                )}

                                {collectionDetails?.ownerName && (
                                    <li>{collectionDetails?.ownerName}</li>
                                )}
                            </ul>
                        </div>
                        <div>
                            <button
                                className='button secondary chat-btn'
                                onClick={() =>
                                    handleOpenConversation(
                                        collectionDetails?.id
                                    )
                                }
                            >
                                <span className='mr-2'>Conversation</span>
                                <ConversationIcon />
                                {collectionDetails?.numOfUnseenComment && (
                                    <span className='count absolute'>
                                        {collectionDetails?.numOfUnseenComment}
                                    </span>
                                )}
                            </button>
                        </div>
                    </div>

                    <div className='design-list-container pt-5 pb-10'>
                        {designs.map((item, i) => (
                            <React.Fragment key={`single_item_${i}`}>
                                <DesignCardView
                                    designInfo={item}
                                    triggerIsFavourite={toggleDesignFavourite}
                                    requestFrom='COLLECTION_LIST_STYLE_VIEW'
                                />
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            )
        })
    }

    return (
        <>
            {renderGroupedDesignCards()}
            {showFavourite && (
                <AddToFavourite
                    isVisible={showFavourite}
                    setIsVisible={setShowFavourite}
                />
            )}

            {openConfirmation && (
                <ConfirmationModal
                    closeModal={() => {
                        setOpenConfirmation(false)
                    }}
                    handleSubmit={() =>
                        toggleCollectionFavourite(true, selectedCollectionId)
                    }
                    title={
                        'Are you sure to add all the styles from this collection to your favourites?'
                    }
                />
            )}
        </>
    )
}

export default SharedCollectionStyleView
